/** gbwhatpro.org 站点常量 */
export const SITE_ORIGIN = 'https://gbwhatpro.org'
export const SITE_NAME = 'GBWhatPro'
export const SITE_DOMAIN = 'gbwhatpro.org'
export const SUPPORT_EMAIL = 'contact@gbwhatpro.org'
export const BRAND_ASSET_VERSION = 'gbpro1'

export function canonical(path) {
	if (!path || path === '/') {
		return `${SITE_ORIGIN}/`
	}
	return `${SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`
}
